import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/friends.webp'

export const Friends: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'study buddy'} />
)
